export default __webpack_public_path__ + "static/media/postventa_scania_camiones.1de56426.pdf";